var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({ backgroundColor: _vm.bgColor })},[_c('h3',{staticClass:"center"},[_c('div',[_vm._v("SLA:")]),(_vm.slaTime === -1)?_c('div',[_vm._v(_vm._s(_vm.$t('components.order.sla_color_block.none')))]):_c('div',[_c('HumanDate',{attrs:{"date":_vm.slaTime}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }